import React, { useEffect } from "react";
import Slider from "../../components/Slider";
import { Box } from '@mui/material';
import CardsSection from "../../components/CardsSection";
import CardActionSection from "../../components/CardActionSection";
import Swal from "sweetalert2";
import { consumeSessionExpiredFlag } from "../../utils/session";
import theme from "../../theme";

const Home = () => {
  useEffect(() => {
    if (!consumeSessionExpiredFlag()) return;

    Swal.fire({
      icon: "info",
      title: "Sesión expirada",
      text: "Tu sesión ha vencido. Puedes iniciar sesión nuevamente cuando lo desees.",
      confirmButtonColor: theme.palette.secondary.main,
    });
  }, []);

  return (
    <Box
      sx={{
        width: "100%", 
        display: "flex", 
        flexDirection: "column", 
        justifyContent: "flex-start",
        alignItems: "center",
        overflowX: "hidden",
      }}
    >
      <Slider/>
      <CardsSection/>
      <CardActionSection/>
    </Box>
  );
};

export default Home;
